import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';
import { usePrivyAccount } from '@/hooks';
import { useEffect, useState } from 'react';
import { useAccountStore } from '@/store/use-account-store';
import { Bell } from 'lucide-react';
import { useModalStore } from '@/store/use-modal-store';
import { SettingsTab } from '@/types';

export default function NotificationsDialog() {
  const { address, hasEmail, isConnected } = usePrivyAccount();

  const [isOpen, setIsOpen] = useState(false);

  const hasPrimaryAuth = useAccountStore((state) => state.hasPrimaryAuth);

  useEffect(() => {
    if (!address || !hasPrimaryAuth || !isConnected || hasEmail) return;
    const received =
      localStorage.getItem(`notifications-${address}`) === 'true';
    if (!received) {
      setIsOpen(true);
      localStorage.setItem(`notifications-${address}`, 'true');
    }
  }, [address, hasPrimaryAuth, isConnected, hasEmail]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-xl sm:rounded-3xl" hideCloseButton>
        <DialogHeader className="gap-2 px-6 pb-5 pt-10 sm:px-10">
          <div className="flex items-center gap-3">
            <Bell size={20} />
            <DialogTitle className="text-xl sm:text-2xl">
              Email notifications are now live!
            </DialogTitle>
          </div>
          <DialogDescription className="text-base/relaxed sm:text-lg/relaxed">
            Stay tuned with alerts on positions and markets.
            {hasEmail &&
              " We've enabled notifications for your account to improve security and usability."}{' '}
            You can customize your notifications in settings.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="grid grid-cols-2 gap-3 px-6 pb-10 sm:px-10">
          <Button size="lg" variant="ghost" onClick={() => setIsOpen(false)}>
            Dismiss
          </Button>
          <Button
            size="lg"
            variant="foreground"
            onClick={() => {
              setIsOpen(false);
              useModalStore.setState({
                activeSettingsTab: SettingsTab.NOTIFICATIONS,
              });
            }}
          >
            Setup Now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
